<template>
  <el-card class="card-main">
    <el-form ref="searchInfo" :model="searchInfo" class="global-form" :inline="true">
      <el-form-item prop="logUserName">
        <el-input v-model="searchInfo.logUserName" placeholder="请输入操作人姓名" clearable />
      </el-form-item>
      <el-form-item prop="logCode">
        <el-input v-model="searchInfo.logCode" placeholder="请输入操作内容" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" stripe v-loading="tableData.loading" :data="tableData.data">
      <el-table-column
        :label="item.label"
        :prop="item.prop"
        :min-width="item.minWidth||''"
        :show-overflow-tooltip = "item.showOverflowTooltip||false"
        v-for="(item,index) in tableData.tr"
        :key="index">
      </el-table-column>
    </el-table>
    <GlobalPagination
      @current-change="getData"
      @size-change="getData"
      :current-page.sync="page"
      :page-size.sync="size"
      :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
export default {
  name: 'logIndex',
  data () {
    return {
      searchInfo: {
        logUserName: '',
        logCode: ''
      },
      tableData: {
        loading: false,
        tr: [
          {
            label: '操作人姓名',
            prop: 'logUserName',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '操作内容',
            prop: 'logCode',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '操作ip',
            prop: 'logIp',
            minWidth: '100',
            showOverflowTooltip: true
          },
          {
            label: '操作时间',
            prop: 'ctime',
            minWidth: '150',
            showOverflowTooltip: true
          }
        ],
        data: [{}]
      },
      total: 0,
      page: 1,
      size: 10
    }
  },
  created () {
    this.getData()
  },
  methods: {
    onSearch () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.tableData.loading = true
      this.$axios.get(this.$apis.system.selectYhLogByPage, {
        page: this.page,
        size: this.size,
        ...this.searchInfo
      }).then((res) => {
        this.tableData.loading = false
        this.total = res.total || 0
        this.tableData.data = res.list || []
      }).catch(() => {
        this.tableData.loading = false
      })
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
